module.exports = __webpack_public_path__ + "static/media/PNG.ab290dfa.svg";